import type { RegistersFilters } from "@services/registers/list/type";
import { defaultFilters } from "@typings/entities/registers/filter";
import { useFilters } from "./useFilters";

export function useRegistersFilters(
  defaults: RegistersFilters = defaultFilters,
) {
  return useFilters<RegistersFilters>({
    defaults,
  });
}
